export default __webpack_public_path__ + "static/media/Sagar Wankhade New CV.a6d03d95.pdf";